import { render, staticRenderFns } from "./reward-privilege.vue?vue&type=template&id=2158ab8a&scoped=true&lang=pug&"
import script from "./reward-privilege.vue?vue&type=script&lang=js&"
export * from "./reward-privilege.vue?vue&type=script&lang=js&"
import style0 from "./reward-privilege.vue?vue&type=style&index=0&id=2158ab8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158ab8a",
  null
  
)

export default component.exports